import React from 'react'
import styled from 'styled-components'
import { md, sans } from '../common'

const Card = ({
  image,
  alt = 'placeholder image',
  bgColor = '#fff',
  textColor = 'black',
  overlapAmt = '50',
  children,
  cardCss,
  mcss
  }) => {
  return(
    <Section cardCss={cardCss} mcss={mcss}>
      <div style={{width: '100%'}}>
        <img style={{ width: '100%'}} src={image} alt={alt} />
      </div>
      <Overlap
      overlapAmt={overlapAmt}
      textColor={textColor}
      bgColor={bgColor}>
        {children}
      </Overlap>
    </Section>
  )
}

export default Card

const Section = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  height: 100%;
  flex: 1;
  ${ props => props.cardCss }

  ${md} {
    ${ props => props.mcss }
  }
`

const Overlap = styled.div`
  width: 80%;
  padding: 1rem;
  align-self: center;
  margin-bottom: .5rem;
  text-align: center;
  background-color: ${ props => props.bgColor };
  color: ${ props => props.textColor };
  z-index: 2;
  margin-top: -${ props => props.overlapAmt }px;

  h2 {
    color: ${ props => props.textColor };
    font-size: 20px;
    font-weight: 400;
  }

  p {
    ${sans};
  }
`
